import {Controller} from "stimulus";

export default class extends Controller {
    connect() {
        this.element.addEventListener('submit', this.handleSubmit);
    }

    handleSubmit = (evt) => {
        this.removeErrorMessages();
        const isValid = this.validations().every((ele) => ele === true);
        if (!isValid) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            window.scrollTo({
                top: document.querySelectorAll('.is-danger')[0].getBoundingClientRect().top + window.pageYOffset - 150,
                behavior: 'smooth'
            });
        }
    }

    lengthErrorMessage(min, max) {
        if (min === max) {
            return `Should be exactly ${min} characters length`;
        }
        return `Should be within ${min} and ${max} characters length`;
    }

    addErrorMessage(element, message) {
        element.classList.add('is-danger');
        const errorText = document.createElement('span');
        errorText.innerText = message;
        errorText.classList.add('help', 'is-danger');
        element.parentNode.append(errorText);
    }

    removeErrorMessages() {
        const helpElements = document.querySelectorAll('.help.is-danger');
        const dangerElements = document.querySelectorAll('.is-danger');
        helpElements.forEach((element) => element.remove());
        dangerElements.forEach((element) => element.classList.remove('is-danger'));
    }

    regexValidation() {
        let isValid = true;
        const regexElements = document.querySelectorAll('input[data-regex]');
        regexElements.forEach((element) => {
            element.classList.remove('is-danger');
            if (element.value !== '' && !element.value.match(element.dataset.regex)) {
                this.addErrorMessage(element, element.dataset.errorMessage || 'Please enter a valid input');
                isValid = false;
            }
        });
        return isValid;
    }

    lengthValidation() {
        let isValid = true;
        const lengthElements = document.querySelectorAll('input[data-length]');
        lengthElements.forEach((element) => {
            const [min, max] = element.dataset.length.split(",").map(Number);
            if (element.value !== '' && !(element.value.length >= min && element.value.length <= max)) {
                this.addErrorMessage(element, element.dataset.errorMessage || this.lengthErrorMessage(min, max));
                isValid = false;
            }
        });
        return isValid;
    }

    validations() {
        return [this.regexValidation(), this.lengthValidation()]
    }
}
